import React, { Component } from 'react';
import TableRow from "@material-ui/core/TableRow";

class EventsTableItem extends Component {

    render() {
        return (
            <TableRow 
                style= {
                    {
                        fontSize: '1.3rem'
                    }
                }
                key={this.props.event.id}>
                    <td>{this.props.event.instance.name}</td>
                    <td>{this.props.event.eventType.name}</td>
                    <td>{new Date(this.props.event.created).toLocaleString('en-GB', { timeZone: 'UTC' })}</td>
                    <td>{this.props.event.description}</td>
                    <td>{this.props.event.summary}</td>
            </TableRow>
        );
    }
}

export default EventsTableItem;


// WEBPACK FOOTER //
// ./src/components/EventsTableItem.js